import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { CustomerProcedureInterface } from '../models/customer-procedure.interface';

@Injectable()
export class CustomerProcedureService {

  constructor(private apiService: ApiService) {}

  /**
   * Get procedures list
   */
  get(procedureType: string, externalId: string): Observable<Array<CustomerProcedureInterface>> {
    return this.apiService.post<Array<CustomerProcedureInterface>>('customer/procedures/list/' + procedureType, {externalId});
  }
}
